import { GenericAbortSignal } from "axios";
import { useEffect, useMemo } from "react";

export default function useCancellationToken(): CancellationToken {
    const controller = useMemo(() => new AbortController(), []);

    useEffect(() => {
        //Just need a destructor
        return () => controller.abort();
    }, []);

    return controller;
}

export interface CancellationToken {
    signal: GenericAbortSignal;
}